import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { getAttrData, queryStoreExpress } from "@/graphql/product.gql";
import { ProductAttributeEnums } from "@/enums/mall";

export interface MallAttributeState {
  _sectionWidth;
  _flatten;
  _hubDiameter;
  _pattern;
  isExpress;
  productAttrData;
  shopExpress: boolean;
}

@Module({ name: "MallAttributeModule", namespaced: true })
export default class MallAttributeModule
  extends VuexModule<MallAttributeState, RootState>
  implements MallAttributeState {
  _sectionWidth: any[] = [];
  _flatten: any[] = [];
  _hubDiameter: any[] = [];
  _pattern: any[] = [];
  isExpress: any[] = [];
  productAttrData = {};
  shopExpress: boolean = false; // 门店是否支持快递

  @Mutation
  saveAttributesMutation(data = {}) {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.productAttrData = data ?? {};
  }
  @Mutation
  saveShopExpressMutation(data = false) {
    this.shopExpress = data ?? false;
  }

  // 获取商品属性数据
  @Action
  async getAttributeDataAction() {
    const data = await queryRequest({
      query: getAttrData,
      variables: {
        codeList: Object.values(ProductAttributeEnums)
      }
    });
    this.context.commit(
      "saveAttributesMutation",
      Object.assign({}, ...data.map(o => ({ [o.attrCode]: o.attrValueList })))
    );
  }

  // 格式化属性
  // get formatAttributeDataGetter() {
  //   return item => {
  //     const attrs = JSON.parse(item?.attribute ?? "{}");
  //     return Object.assign(
  //       {},
  //       ...Object.keys(attrs).map(key => {
  //         const { attrValueName } =
  //           this.productAttrData[key]?.find(
  //             o => o.attrValueCode === attrs[key]
  //           ) ?? {};
  //         return { [key]: attrValueName };
  //       })
  //     );
  //   };
  // }

  @Action
  async queryStoreExpressAction() {
    // const { success } = await queryRequest({
    //   query: queryStoreExpress
    // });
    // this.context.commit("saveShopExpressMutation", success);
  }
}
